module.exports = __webpack_public_path__ + "img/Sidebar Toggle Right.38ccbf94.svg";